<template>
  <div>
    <div class="input-group">
      <input
        type="text"
        ref="text"
        class="form-control"
        v-model="value"
        @focus="onFocus"
        v-bind="$attrs"
      >
      <span
        class="add-on"
        v-if="!$attrs.disabled"
      >
        <img
          v-if="!value.label"
          :src="`${$root.cdnUrl}assets/icon-arrow-down-gray.svg`"
        >
        <img
          v-else
          :src="`${$root.cdnUrl}assets/icon-close-gray.svg`"
          @click="clear"
        >
      </span>
    </div>

    <Modal
      :show="showModal"
      @close="close"
      class="modal-select"
    >
      <template slot="modal-body">
        <div
          class="header"
        >
          <span
            @click="close"
          >
            Geri
          </span>
          <span
            class="header-title"
          >{{ $attrs.title }}</span>
          <span />
        </div>
        <div class="content">
          <div class="input-group search left">
            <input
              type="text"
              ref="search"
              class="form-control"
              placeholder="Ara"
              v-model="search"
              @input="onSearch"
            >
            <span class="add-on">
              <img :src="`${$root.cdnUrl}assets/icon-search.png`">
            </span>
          </div>
          <ul class="options">
            <li
              v-for="(option, k) in getOptions"
              :key="k"
              @click="onClick(option)"
            >
              <GCheckbox
                v-model="option.isChecked"
              />
              <span
                :class="{'checked' : option.isChecked}"
              >
                {{ option.label }}
                <small>
                  <b>{{ option.subLabel }}</b>
                </small>
              </span>
            </li>
            <li v-if="!getOptions.length">
              <span>Kayıt Bulunamadı.</span>
            </li>
          </ul>
        </div>
      </template>
      <template slot="modal-footer">
        <GButton
          class="clear-button"
          @click="clear"
        >
          Temizle
        </GButton>
        <GButton
          class="submit-button"
          @click="submit"
        >
          Uygula
        </GButton>
      </template>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/pages/AddFromCatalog/Modals/Modal';
import GButton from '@trendyol-js/grace/core/GButton';
import GCheckbox from '@trendyol-js/grace/core/GCheckbox';
import { distance } from 'fastest-levenshtein';

export default {
  components: { Modal, GButton, GCheckbox },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    max: {
      type: Number,
      default: () => 100,
    },
  },
  data () {
    return {
      search: '',
      showModal: false,
      selectedOptions: [],
      selectedNames: [],
    };
  },
  computed: {
    getOptions () {
      const options = this.options;
      const search = this.search.toLocaleLowerCase('tr-TR').trim();
      if (options.length > 100) {
        return options
          .filter(option => option.label.toLowerCase().search(search) > -1)
          .sort((a, b) => distance(a.label.toLowerCase(), search) - distance(b.label.toLowerCase(), search))
          .splice(0, this.max);
      }
      return options.filter(option => option.label.toLocaleLowerCase('tr-TR').search(search) > -1)
        .map(option => ({
          ...option,
          order: option.label.toLowerCase().search(search),
        }))
        .sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
    },
    getTitle () {
      return this.$attrs.title;
    },
  },
  methods: {
    onSearch () {
      this.$emit('onSearch', this.search);
    },
    async onFocus () {
      this.showModal = true;
      await this.$nextTick();
      this.$refs.text.blur();
      this.$emit('toggleModal', this.showModal);
    },
    onClick (selectedOption) {
      this.options.forEach(option => {
        if (selectedOption.id === option.id) {
          option.isChecked = !option.isChecked;
        }
      });
    },
    submit () {
      this.options.map(option => {
        if (option.isChecked) {
          this.selectedOptions.push(option.id);
          if (this.selectedNames.indexOf(option.label) === -1) {
            this.selectedNames.push(option.label);
          }
        }
      });
      this.$emit('filter', this.selectedOptions, this.selectedNames);
      this.close();
    },
    close () {
      this.showModal = false;
      this.$emit('toggleModal', this.showModal);
    },
    clear () {
      this.options.map(option => {
        if (option.isChecked) {
          option.isChecked = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  .options {
    border-top: 1px solid #DEE0EB;
    list-style: none;
    margin: 0;
    padding: 0;
    overflow: auto;
    max-height: 80vh;
    li {
      position: relative;
      border-bottom: 1px solid #DEE0EB;
      display: flex;
      align-items: center;
      .checked {
        color: #F27A1A;
      }
      span {
        display: block;
        padding: 15px;
        padding-right: 35px;
        position: relative;
        img {
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translateY(-50%);
        }
      }
    }
  }
  .input-group {
    margin-bottom: 15px;
  }
}

.modal-select {
  ::v-deep .modal {
    border-radius: 15px 15px 0 0;
    .modal-body {
      min-height: 400px;
      .header {
        display: flex;
        height: 40px;
        align-items: center;
        gap: calc((100% / 2) - 55px);
        .header-title {
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #273142;
        }
      }
    }
    @media screen and (max-height: 550px) {
      top: initial;
      bottom: 0;
      .modal-body {
        min-height: 1px;
        .content {
          margin: 0;
          .options {
            max-height: 200px;
          }
        }
      }
      padding: 0 15px;
    }
    .modal-footer {
      position: absolute;
      display: flex;
      gap: 15px;
      width: 100%;
      bottom: 0;
      left: 0;
      border-radius: 6px;
      padding: 15px;
      color: white;
      height: 80px;
      box-shadow: 0px -8px 15px rgba(39, 49, 66, 0.15);
      .submit-button {
        width: 65%;
        background: #F27A1A;
        border-radius: 6px;
      }
      .clear-button {
        width: 30%;
        background: #AFBBCA;
        border-radius: 6px;
      }
    }
  }
}
</style>
